import { render, staticRenderFns } from "./PluginsIntegratedTab.vue?vue&type=template&id=3ed29052&scoped=true&"
import script from "./PluginsIntegratedTab.vue?vue&type=script&lang=js&"
export * from "./PluginsIntegratedTab.vue?vue&type=script&lang=js&"
import style0 from "./PluginsIntegratedTab.vue?vue&type=style&index=0&id=3ed29052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed29052",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VBtn,VIcon,VSimpleTable})
